import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {Link, useParams} from "react-router-dom";
import {Button, Rate, Space, Spin} from 'antd';
import TeamTable from "../TeamTable";
import {fillZero, globalData} from "../../util/util";
import Icon from "../Icon";
import ButtonGroup from "antd/es/button/button-group";

export default (prop) => {

    const {t} = useTranslation()
    const id = useParams().id
    const [loading,setLoading] = useState(false)
    const [game,setGame] = useState({})
    const [star,setStar] = useState(0)

    let player
    if (game && game.playerList) {
        player = game.playerList[0]
    }

    useEffect(() => {
        setTimeout(() => {
            let game0 = globalData("game");
            if (!game0) {
                axios.get(`game/info/${id}`).then(res => {
                    setGame(res)
                    if (game.playerList) {
                        player = game.playerList[0]
                    }
                    setLoading(false)
                })
            } else {
                if (game0.fold != 1) {
                    if ( (id && id != game.id) || (game0.recordStatus == 0) ) {
                        if (game0.recordStatus != 0) {
                            setLoading(true)
                        }
                        axios.get(`game/info/${id}`).then(res => {
                            setGame(res)
                            if (game.playerList) {
                                player = game.playerList[0]
                            }
                            setLoading(false)
                        })
                    }
                }
            }


        }, 10)
    }, [id])

    useEffect(() => {
        let game0 = prop.game ?  prop.game : globalData("game")
        if (game0) {
            // game.id = game0.id
            setGame(game0)
        }
    }, [prop.game])

    useEffect(() => {
        if (game.id) {
            axios.get(`like/info/${game.id}`).then(res => {
                setStar(res)
            })
        }

    }, [game.id])

    const getColor = (team) => {
        if (game.winner == 0) {
            return "#ffec3d"
        } else {
            return game.winner == team && "#52c41a" || "#f5222d"
        }
    }

    const GetModeName = (game) => {
        if (game.gameMode === 3) {
            return t('mode.competition')
        }
        return game.playerList.length === 1 && t('mode.single') || t(`mode.0_${game.mode}`) + t(`mode.1_${game.mode2}`)
    }

    return loading ? <Spin /> : <>
        {
            game.id ? <Space direction={'vertical'}>

                <Space size={36}>

                    <div style={{width: "200px"}}>
                        {
                            game.winner == 0 && <span style={{color: "#ffec3d", fontSize: '32px'}}>{t('playing')}</span>
                            || <span style={{color: "#52c41a", fontSize: '32px'}}>{`${t('team')}${game.winner} ${t('win')}`}</span>
                        }
                    </div>

                    <Space size={24}>
                        <div style={{filter: "grayscale(80%)", width: "72px"}} >
                            {
                                game.mode2 == 2 && game.gameBanList.sort((a, b) => a.seq - b.seq).filter(g => g.team == 1).map(g => <Icon key={g.heroId} type={'hero'} name={g.heroId} size={36} />)
                            }
                        </div>
                        <div style={{color: getColor(1), fontSize: '32px', width: "64px"}}>{game.team1wins}</div>
                        <Space direction={'vertical'}>
                            <div style={{width: "160px"}}>{GetModeName(game)}</div>
                            <div>{`${Math.floor(game.frame / 16 / 1.4 / 60)}:${fillZero(Math.floor(game.frame / 16 / 1.4) % 60)}`}</div>
                        </Space>
                        <div style={{color: getColor(2), fontSize: '32px', width: "64px"}}>{game.team2wins}</div>
                        <div style={{filter: "grayscale(80%)", width: "72px"}} >
                            {
                                game.mode2 == 2 && game.gameBanList.sort((a, b) => a.seq - b.seq).filter(g => g.team == 2).map(g => <Icon key={g.heroId} type={'hero'} name={g.heroId} size={36} />)
                            }
                        </div>
                    </Space>
                    <Space size={20}>
                        <Rate style={{fontSize: "30px"}} value={star} count={1} onChange={(v) => {
                            setStar(v)
                            if (v === 1){
                                axios.post(`like/add/${game.id}`).then()
                            } else if(v === 0) {
                                axios.post(`like/remove/${game.id}`).then()
                            }
                        }}/>
                        <div style={{fontSize: '28px', width: "160px"}}>{t('region.region')}: <Icon type={'region'} name={game.region} size={32} /></div>
                    </Space>
                </Space>
                {
                    game.playerList.length == 1 && <Link style={{fontSize: "38px"}} to={`/player/${player.playerHandle}`}><span>{player.playerName}</span></Link> ||
                    <>
                        <TeamTable heroId={prop.heroId} playerHandle={prop.playerHandle} game={game} team={1} />
                        <TeamTable heroId={prop.heroId} playerHandle={prop.playerHandle} game={game} team={2} />、
                    </>
                }

            </Space> : null
        }

    </>
}
